import axios from "axios";
const baseURL: any = process.env.REACT_APP_API_URL;

export function sendLeaderMomLogin(data: any) {
  return axios.post(`${baseURL}/auth/ml`, data);
}
